var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeuiBackFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 42,
    viewBox: "0 0 21 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85035 21.0001L18.2246 33.3744L15.7501 35.8489L2.1386 22.2374C1.81052 21.9092 1.62622 21.4642 1.62622 21.0001C1.62622 20.5361 1.81052 20.091 2.1386 19.7629L15.7501 6.15137L18.2246 8.62587L5.85035 21.0001Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeuiBackFilled);
export default __webpack_public_path__ + "static/media/weui_back-filled.d1a4c61d40f777dffef676f19f8403d2.svg";
export { ForwardRef as ReactComponent };